import React from 'react'
import createReactClass from 'create-react-class'


/**
 * If there are any bootstrap errors, this component will be shown along with the errors
 */
var BootstrapError = createReactClass({
  render: function() {

  	return (
      <div style={{'width': '50%', 'margin': '30px auto'}}>
        <h2>There was an error loading the Online Prints Editor</h2>
        <div>{this.props.message}</div>
      </div>
    );
  }
});

export default BootstrapError;
